<script setup>
import { onMounted, ref } from 'vue'
import DataLayer from '@services/data-layer/index'
import PlaylistsGridBlock from '@components/playlists/playlists-grid-block'

const charts = ref([])
const featuredCharts = ref([])

// A chart with no published revision has no cover art and no tracklist to show.
const isPublished = playlist =>
    playlist.revisions_id !== null &&
    playlist.revisions_album_art &&
    playlist.revisions_album_art.filename

onMounted(() => {
    DataLayer.playlists.getByType({ type: 'chart' }).then(response => {
        response.body.filter(isPublished).forEach(playlist => {
            if (playlist.featured === 1) {
                featuredCharts.value.push(playlist)
            } else {
                charts.value.push(playlist)
            }
        })
    })
})
</script>

<template>
    <div class="explore-charts">
        <BaseSection
            v-if="featuredCharts && featuredCharts.length"
            title="Featured Charts"
            padded
        >
            <PlaylistsGridBlock
                :playlists="featuredCharts"
                type="charts"
            />
        </BaseSection>
        <BaseSection padded>
            <PlaylistsGridBlock
                :playlists="charts"
                type="charts"
            />
        </BaseSection>
    </div>
</template>
